// extracted by mini-css-extract-plugin
export var container = "Career-module--container--0b6cc";
export var head = "Career-module--head--2124c";
export var leftBackground = "Career-module--left-background--4869d";
export var ranking = "Career-module--ranking--f979a";
export var rightBackground = "Career-module--right-background--010a2";
export var wrapper = "Career-module--wrapper--8c6c6";